skrilla.directive('queryBetsForTicker', function ($window, betService) {
    return {
        templateUrl: 'directives/queryBets/queryBetsForTicker.html',
        scope: {
            bets: "=",
            key: "=",
            queryKey: "=",
            userId: "=",
            marketId: "=",
            subtitle: "="
        },
        controller: async function ($scope,
                                    $state,
                                    searchService,
                                    queryService,
                                    paginationService,
                                    cacheService,
                                    sportService,
                                    currencyService,
                                    constantsService) {
            $scope.refresh = true;
            $scope.rate = 10;

            function refresh(){
                setTimeout(function () {
                    if($state.current.name === "betTicker") {
                        if ($scope.refresh) {
                            $scope.search();
                        }
                        refresh();
                    }else{
                        console.log("Left bet ticker page. Stopping search.")
                    }
                }, getRate())
            }refresh();

            function getRate(){
                //Angulars min / max sends undefined if an invalid number is entered.
                let rate = $scope.rate * 1000;
                if(isNaN(rate)){
                    rate = 10000;
                    $scope.rate = 10;
                }
                return Math.max(rate, 10000)
            }

            $scope.sports = await sportService.getSports();
            $scope.currencies = currencyService.getCurrencies();
            $scope.queryKey = $scope.queryKey || "queryBets";
            $scope.marketingCategories = constantsService.getMarketingCategories();
            $scope.sortBy = {
                CREATED_AT: 'Created At',
                UPDATED_AT: 'Updated At',
                PAID_OUT: 'Paid out',
                POTENTIAL_PAYOUT: 'Potential Payout',
                STAKE: 'Stake'
            }
            $scope.totalBets = 0
            $scope.betLimit = 100000

            $scope.setUser = function () {
                $scope.query.userId = $scope.userId === undefined ? "" : $scope.userId;
            }
            $scope.reset = function () {
                $scope.query = {
                    limit: 20,
                    sport: null,
                    statuses: {
                        CREATED: true,
                        ACCEPTED: true,
                        LIVE: true,
                        REJECTED: !$scope.marketId,  //todd doesn't want rejected bets in market bet page,
                        SETTLED: true,
                        CANCELLED: true,
                        VOID: true
                    },
                    marketingCategories: constantsService.getMarketingCategoriesForQuery(),
                    results: {
                        UNDECIDED: true,
                        WIN: true,
                        LOSE: true,
                        VOID: true
                    },
                    sortOrder: 'DESC'
                };
                $scope.setUser()
                $scope.loading = false;
            };
            $scope.query = cacheService.getObject($scope.queryKey)
            if (!$scope.query || $scope.marketId) {
                $scope.reset()
            } else {
                //always set the user so we dont end up with an old user id
                $scope.setUser()
            }

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getBets, $scope.key);
            }

            function queryParams() {
                $scope.query.limit = Math.min($scope.query.limit, 50)
                if(isNaN($scope.query.limit)){
                    $scope.query.limit = 20;
                }
                const query = {
                    ...$scope.query,
                    minimumPayout: $scope.query.minimumPayout ? $scope.query.minimumPayout * 100 : null,
                    maximumPayout: $scope.query.maximumPayout ? $scope.query.maximumPayout * 100 : null,
                    minimumWinnings: $scope.query.minimumWinnings ? $scope.query.minimumWinnings * 100 : null,
                    maximumWinnings: $scope.query.maximumWinnings ? $scope.query.maximumWinnings * 100 : null,
                    minimumStake: $scope.query.minimumStake ? $scope.query.minimumStake * 100 : null,
                    maximumStake: $scope.query.maximumStake ? $scope.query.maximumStake * 100 : null
                };
                query.marketId = $scope.marketId
                cacheService.registerObject($scope.queryKey, $scope.query)
                const queryParams = queryService.getQueryString(query, $scope.key);
                return queryParams;
            }


            var getBets = function () {
                $scope.loading = true
                return searchService.get("bets" + queryParams(), true, true)
                .then(function (response) {
                    $scope.bets = response.data.result;
                    $scope.totalBets = response.data.totalEntities;
                    $scope.bets.forEach(function (bet) {
                        bet.odds = betService.deriveOdds(bet)
                    });
                    cacheService.registerObject("betsTable", $scope.bets);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                }).finally(() => {
                    $scope.loading = false;
                });
            }


            $scope.exportCsv = function () {
                $scope.downloadingCsv = true;

                searchService.get("bets/export" + queryParams())
                    .then(res => {
                        const blob = new Blob([res.data], {type: 'text/plain'});
                        const file = $window.URL.createObjectURL(blob);
                        const tempLink = $window.document.createElement('a');
                        tempLink.style.display = 'none';
                        tempLink.href = file;
                        const filename =$scope.exportFilename + ($scope.exportFilename.endsWith(".csv") ? "": ".csv");
                        tempLink.setAttribute('download', filename);

                        $window.document.body.appendChild(tempLink);
                        tempLink.click();
                        $window.document.body.removeChild(tempLink);

                        return file
                    }).finally(file => {
                    $window.URL.revokeObjectURL(file)
                    $scope.downloadingCsv = false
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
